import * as React from 'react'
import { Route, RouteProps, Redirect } from 'react-router'
import { isAuthenticated } from '../utils/auth'

const NotLoggedRoute: React.SFC<RouteProps> = ({
  component: Component,
  render,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthenticated()) {
        return <Redirect to="/my-loans" />
      }

      const toRender =
        Component != null ? (
          <Component {...props} />
        ) : render != null ? (
          render(props)
        ) : (
          <div />
        )

      return toRender
    }}
  />
)

export default NotLoggedRoute



// WEBPACK FOOTER //
// ./src/components/NotLoggedRoute.tsx